"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'isMobileView'], function (_a, carmiProps) {
    var compData = _a.compData, compProps = _a.compProps, isMobileView = _a.isMobileView;
    return __assign(__assign({}, carmiProps), { rtl: compProps.direction === 'rtl', labelPosition: isMobileView && compProps.labelPosition === 'side'
            ? 'top'
            : compProps.labelPosition, showTitle: compProps.showTitle, title: compData.titleText, showLabels: compProps.showLabels, value: compData.value, labels: compData.labels, isDisabled: compProps.isDisabled, required: compProps.required });
});
var iconsMarginCss = function (compProps, labelPosition) {
    var shapeSize = compProps.shapeSize, shapeSpacing = compProps.shapeSpacing;
    var margin = (labelPosition === 'side' ? Math.max(15, shapeSpacing) : shapeSize / 2) + "px";
    if (labelPosition === 'top') {
        return { '--iconsMarginTop': margin };
    }
    else if (labelPosition === 'bottom') {
        return { '--iconsMarginBottom': margin };
    }
    if (compProps.direction === 'rtl') {
        return { '--iconsMarginLeft': margin };
    }
    return { '--iconsMarginRight': margin };
};
var notSideCss = function (compProps, iconSize) {
    var inputAlignment = {
        center: 'center',
        left: compProps.direction === 'rtl' ? 'flex-end' : 'flex-start',
        right: compProps.direction === 'rtl' ? 'flex-start' : 'flex-end',
    };
    return {
        '--labelsContainerWidth': iconSize,
        '--inputAlignItems': inputAlignment[compProps.labelAlignment],
        '--inputFlexDirection': 'column',
    };
};
exports.css = withCompInfo_1.withCompInfo(['compProps', 'isMobileView'], function (_a, carmiCss) {
    var _b;
    var compProps = _a.compProps, isMobileView = _a.isMobileView;
    var showTitle = compProps.showTitle, showLabels = compProps.showLabels, shapeSize = compProps.shapeSize, shapeSpacing = compProps.shapeSpacing, labelAlignment = compProps.labelAlignment, direction = compProps.direction;
    var iconSize = shapeSize * 5 + shapeSpacing * 4 + "px";
    var labelPosition = isMobileView && compProps.labelPosition === 'side'
        ? 'top'
        : compProps.labelPosition;
    var rtl = direction === 'rtl';
    var labelsContainerAlignment = {
        top: 'flex-end',
        bottom: 'flex-start',
        side: 'center',
    };
    var cssVars = __assign(__assign({}, carmiCss), (_b = { '--inputAlignItems': 'center', '--inputFlexDirection': 'row', '--iconsMinWidth': iconSize, '--iconsOrder': labelPosition === 'top' ? 2 : 0, '--labelsContainerAlignItems': labelsContainerAlignment[labelPosition], '--inputTextAlign': "" + labelAlignment, '--iconSize': shapeSize + "px" }, _b["--iconPadding" + (rtl ? 'Left' : 'Right')] = shapeSpacing + "px", _b['--direction'] = direction, _b));
    if (labelPosition !== 'side') {
        cssVars = __assign(__assign({}, cssVars), notSideCss(compProps, iconSize));
    }
    if (isMobileView && rtl) {
        // in certain layout cases component height is incorrect in site structure. Possible negative effect - label text invisible on mobile
        cssVars = __assign(__assign({}, cssVars), { height: 'auto' });
    }
    if (showTitle || showLabels) {
        return __assign(__assign({}, cssVars), iconsMarginCss(compProps, labelPosition));
    }
    return cssVars;
});
//# sourceMappingURL=RatingsInput.js.map